const {
    filter, some, forEach,
} = require('lodash');

class ProductGroupService {
    constructor(restangular, $q, settings, sortByKeys, $location) {
        this._productGroupRoute = restangular.one('ProductGroup');
        this.selectedGroup = undefined;
        this.settings = settings;
        this.sortByKeys = sortByKeys;
        this.$q = $q;
        this.$location = $location;

        this.items = [];
        this._groupCache = {};
    }

    selectProductGroup(id) {
        if (!(id in this._groupCache)) {
            this._groupCache[id] = this._productGroupRoute.one(id).get();
        }

        this.productGroupPromise = this._groupCache[id].then((response) => {
            this.selectedGroup = response;
            return response;
        });

        return this.productGroupPromise;
    }

    getSelectedProductGroup() {
        return this.productGroupPromise
            ? this.productGroupPromise
            : this.$q.when({});
    }

    listForVisualShopping() {
        return this._productGroupRoute.one('ListForVisualShopping').get().then((items) => {
            this.items = items;
            return items;
        });
    }

    getProducts(pageSize, pageNumber, sortType, filters) {
        this.selectedGroupTotalCount = undefined;
        return this._productGroupRoute.one('Products').post(this.selectedGroup.Url, {
            PageNumber: pageNumber,
            PageSize: pageSize || 10,
            SortType: sortType,
            Filters: filters ? filters.filters : [],
            Location: this.$location.url(),
        }).then((response) => {
            this.selectedGroupTotalCount = response.TotalRecordCount;
            return {
                items: response.Items,
                totalRecordCount: response.TotalRecordCount,
                aggregations: filter(response.Aggregations, a => a.ShowFilter), // later we will need to accommodate multiple aggregations from this point on
            };
        });
    }

    isGroupEligibleForRanking() {
        return !!(this.selectedGroup && this.selectedGroup.IsEligibleForRanking);
    }

    getSortOptions() {
        const sortGroup = this.isGroupEligibleForRanking()
            ? 'productGroup'
            : 'browse';

        return {
            sortTypes: this.settings[sortGroup].sortOptions,
            sortContext: this.sortByKeys.PRODUCT_GROUPS_KEY,
        };
    }

    getDepartmentGroup(departments, includedDepartmentIds) {
        let selectedDepartment = 'Other';

        // if a product has multiple departments - we only want to display the department that is part of the main departments (whitelisted)
        // eslint-disable-next-line consistent-return
        forEach(departments, (department) => {
            if (some(includedDepartmentIds, departmentId => departmentId.toLowerCase() === department.Id.toLowerCase())) {
                selectedDepartment = department.Description;
                // this how we exit from the foreach loop in lodash by returning false
                return false;
            }
        });

        return selectedDepartment;
    }
}

ProductGroupService.$inject = ['Restangular', '$q', 'Settings', 'SortByKeys', '$location'];

module.exports = { ProductGroupService };



// WEBPACK FOOTER //
// ./src/shop/productgroups/productgroup.service.js